import React from "react";
import { Outlet } from "react-router-dom";
import { AdminSidebar, AdminTopBar } from "../../components/AdminSidebar";
import { Toaster } from "sonner";
import PushPermissionPrompt from "../../components/PushPermissionPrompt";

export default function AdminLayout() {
  return (
    <div className="min-h-screen bg-paper md:pl-64" data-testid="admin-layout">
      <AdminSidebar />
      <AdminTopBar />
      <PushPermissionPrompt />
      <main className="px-6 py-8">
        <Outlet />
      </main>
      <Toaster position="top-right" richColors offset={16} />
    </div>
  );
}
